import { parse, parseISO } from 'date-fns';

/**
 * Parses a date string safely into a local Date object.
 * If the string is a date-only format (YYYY-MM-DD), it parses it as local midnight
 * to ensure date-fns treats it as local time rather than UTC,
 * preventing timezone shift bugs (e.g. April 8th becoming April 7th in negative offset timezones).
 *
 * @param dateStr The date string to parse.
 * @returns A Date object representing the local time equivalent.
 */
export const parseLocalDate = (dateStr: string | Date | null | undefined): Date => {
    if (!dateStr) return new Date(NaN);
    if (dateStr instanceof Date) return dateStr;
    
    // If it's exactly YYYY-MM-DD (length 10), parse as local midnight
    if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return parse(dateStr, 'yyyy-MM-dd', new Date());
    }
    
    // Otherwise rely on parseISO for full timestamps
    return parseISO(dateStr);
};

/**
 * Formats a date or ISO string into standard Australian format (DD/MM/YYYY).
 */
export const formatDateAu = (date: Date | string | null | undefined): string => {
    if (!date) return '';
    const d = typeof date === 'string' ? parseLocalDate(date) : date;
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-AU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

